import { type FC } from 'react'
import Link from 'next/link'
import { type FooterProps } from './Footer.interface'
import styles from './Footer.module.scss'

export const Footer: FC<FooterProps> = ({
  copyrightText,
  footerLinks,
  siteByLabel,
  siteByLink,
  noContainer
}) => (
  <footer className={styles.container}>
    <div className={noContainer ? 'true' : 'container'}>
      <div className={styles.grid}>
        <nav>
          <ul className={styles.list}>
            <li className={styles.item}>
              {/* eslint-disable-next-line react/no-danger */}
              <span dangerouslySetInnerHTML={{ __html: copyrightText }} />
            </li>
            {footerLinks.map((item) => (
              <li key={item.id} className={styles.item}>
                <Link href={item.url} className={styles.link}>
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <p className={styles.text}>
          {siteByLabel}
          {' '}
          <a href={siteByLink.url} target="_blank" rel="noreferrer">{siteByLink.text}</a>
        </p>
      </div>
    </div>
  </footer>
)
